<template>
  <section
    class="dynamic-list-mobile weakFadeInUp"
    id="dynamicList"
    ref="dynamicList"
    v-loading="listLoading"
  >
    <div class="plateName">{{ categoryName }}</div>

    <div class="content-list">
      <article-box
        v-for="(item, index) in articleList"
        :key="item.id"
        class="article-box"
        @click.native="handleShowDetail(categoryId, item.id, index)"
        :articleData="item"
      />
    </div>
  </section>
</template>

<script>
import ArticleBox from "../../../components/ArticleBox/mobile/large";
import Config from "utils/Config";
import Vconsole from "vconsole";
import { getArticleListByDetail } from "@/api/dynamic.js";
import { DYNAMICIN_FORMATION, DYNAMIC_ACTIVITY } from "@/data/dynamicData.js";
export default {
  name: "dynamicMobileList",
  props: {},
  components: {
    ArticleBox,
  },
  data() {
    return {
      categoryId: "",
      categoryName: "",
      showFixeNav: 0,
      articleList: [], // 企业文化文章
      initArticleNum: 3, // 初始化时的文章数
      articleNum: 3, // 每次滚动加载新增文章数
      listLoading: false,
      finishedDataLoad: false,
    };
  },
  created() {
    const params = window.location.search.split("=")[1];
    this.categoryId = params;
    switch (Number(params)) {
      case DYNAMICIN_FORMATION:
        this.categoryName = "企业资讯";
        break;
      case DYNAMIC_ACTIVITY:
        this.categoryName = "文化活动";
        break;
      default:
        break;
    }

    this.getCategoryList(this.categoryId, this.initArticleNum);

    if (process.env.NODE_ENV !== "production") this.vconsoel = new Vconsole();
    window.addEventListener("scroll", this.scrollHandle, true);
  },
  mounted() {},
  methods: {
    // 分Id取文章列表
    async getCategoryList(categoryId, pageSize) {
      try {
        this.listLoading = true;

        const paramMap = {
          categoryId: categoryId,
          pageSize: pageSize,
        };

        const res = await getArticleListByDetail(paramMap);
        if (!res.data) return;

        if (this.articleList.length === res.data.page.list.length) {
          console.log("======数据加载完毕======");
          this.finishedDataLoad = true;
        }
        this.articleList = res.data.page.list;
      } catch (error) {
        console.error(error);
      } finally {
        this.listLoading = false;
      }
    },
    scrollHandle() {
      const flag = this.judeScroll(); // 根据scroll距离动态新增文章

      if (this.srollFlag !== flag) {
        this.srollFlag = flag;
      } else {
        return;
      }

      if (this.srollFlag && !this.finishedDataLoad) {
        console.log("===== 触发接口======");
        const curNum = this.initArticleNum + this.articleNum;
        this.initArticleNum = curNum;
        this.getCategoryList(this.categoryId, curNum);
      }
    },
    judeScroll() {
      let flag = false;
      // 兼容浏览器
      var clientHeight =
        document.documentElement.scrollTop === 0
          ? document.body.clientHeight
          : document.documentElement.clientHeight;
      var scrollTop =
        document.documentElement.scrollTop === 0
          ? document.body.scrollTop
          : document.documentElement.scrollTop;
      var scrollHeight =
        document.documentElement.scrollTop === 0
          ? document.body.scrollHeight
          : document.documentElement.scrollHeight;

      if (scrollTop != 0 && clientHeight + scrollTop + 300 >= scrollHeight) {
        flag = true;
      } else {
        flag = false;
      }

      return flag;
    },
    handleShowDetail(categoryId, articleId, index) {
      window.location.href = `${Config.domain}/dynamicDetail.html?categoryId=${categoryId}&id=${articleId}&index=${index}`;
    },
  },
};
</script>

<style lang="less" scoped>
.dynamic-list-mobile {
  width: 100%;
  position: relative;
  font-family: PingFangSC-Medium, PingFang SC;

  .plateName {
    font-size: 24px;
    font-weight: 500;
    text-align: center;
    padding: 20px 0;
  }

  .content-list {
    width: 89.3%;
    margin: 0 auto;
    display: grid;
    justify-content: center;
    align-items: center;
    grid-template-columns: repeat(1, 100%);
    grid-gap: 20px;
    padding-bottom: 40px;
    position: relative;

    .article-box {
      height: 417px;
    }
  }
}

//控制模块上移的动画
.weakFadeInUp {
  animation-name: weakFadeInUp;
  animation-duration: 1s;
}

@keyframes weakFadeInUp {
  0% {
    transform: translateY(50px);
  }

  100% {
    transform: translateY(0px);
  }
}
</style>